import { EditInvoiceComponent } from "../editInvoice/EditInvoiceComponent";

import { useAppSelector } from "../../../app/hooks";
import { selectById } from "../invoiceDetailedSlice";

export const NewInvoicePage = () => {
  const invoiceFromStore = useAppSelector((state) => selectById(state, ""));

  return <EditInvoiceComponent existingInvoices={[invoiceFromStore!!]} />;
};
